import { render, staticRenderFns } from "./StateCountBadges.vue?vue&type=template&id=655e8603&scoped=true&"
import script from "./StateCountBadges.vue?vue&type=script&lang=js&"
export * from "./StateCountBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e8603",
  null
  
)

export default component.exports